var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"col-sm-12 col-md-6 col-lg-4"},[_c('router-link',{attrs:{"to":'/' + item.slug}},[_c('div',{staticClass:"item d-flex flex-row align-items-center"},[_c('div',[_c('img',{attrs:{"src":'static/icons/' + item.slug + '.svg',"alt":item.title}})]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(item.title))])])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35529c6b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/List.vue
// module id = 79
// module chunks = 0